import { SetMap } from '@kb3d/models/classes/handlers';

export interface TopologicalSortResult<T> {
    /** the topologically sorted result set */
    sorted: Set<T>;
    /** if any cycles were detected (which is not good), they are returned here */
    cycles: T[][];
}

/**
 * Does a topological sort of directed graph with cycle detection and warning.
 * @param nodes a map where the key is the node and value is an array containing the nodes the key node depends on
 * @param nameSelector function that returns a descriptive name for the node
 */
export function topologicalSort<T>(nodes: SetMap<T, T>, nameSelector: (node: T) => string) {
    const visited = new Set<T>();
    const path = new Set<T>();
    const sorted = new Set<T>();
    const cycles = new Array<T[]>();

    for (const [node] of nodes) {
        recurse(nodes, nameSelector, node, visited, path, sorted, cycles);
    }

    // console.log(`Original graph: ${getDescriptor(nameSelector, ...nodes.keys())}`);
    // console.log(`Sorted graph:  ${getDescriptor(nameSelector, ...sorted)}`);

    return {
        sorted,
        cycles,
    } as TopologicalSortResult<T>;
}

function recurse<T>(
    nodes: SetMap<T, T>,
    nameSelector: (node: T) => string,
    node: T,
    visited: Set<T>,
    path: Set<T>,
    sorted: Set<T>,
    cycles: T[][]
) {
    if (path.has(node)) {
        const items = [...path].reverse();
        cycles.push(items);
        //console.warn(`Cycle detected:  ${getDescriptor(nameSelector, ...path, node)}`);
    }

    if (visited.has(node)) return;
    visited.add(node);
    path.add(node);

    const edges = nodes.get(node);
    if (edges) {
        for (const edge of edges) {
            recurse(nodes, nameSelector, edge, visited, path, sorted, cycles);
        }
    }

    path.delete(node);
    sorted.add(node);
}

// function getDescriptor(nameSelector: (n: any) => string, ...nodes: any[]){
//     return nodes.map(n => nameSelector(n)).join(" -> ");
// }
